import { Wrench } from 'lucide-react';

const TodoPanel = ({ title = 'Endpoint requerido', items = [] }) => {
  if (!items.length) return null;

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-4">
      <div className="flex items-start gap-3">
        <Wrench className="mt-0.5 h-5 w-5 text-amber-700" />
        <div>
          <h3 className="font-semibold text-amber-900">{title}</h3>
          <ul className="mt-2 space-y-1 text-sm text-amber-900">
            {items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TodoPanel;
